<script setup lang="ts">
const { data } = await useAsyncData(                        // For generate time request
  'latest-posts',
  () => useApiBlog().getLatestPosts(3),
  { default: () => [] },
);

const props = defineProps<{ title: string, desc: string }>();
const posts = ref<TBlogPost[]>(data.value ?? []);

onMounted(async () => {
    const res = await useApiBlog().getLatestPosts(3);       // For client side request
    if (!res) return;
    posts.value = res;
});
</script>

<template>
    <SectionsBase id="blog" class="background">
        <div class="container">
            <ChipsDivider>وبلاگ</ChipsDivider>
            <h2>{{ props.title }}</h2>
            <p class="text-body1-semibold text-gray-400 text-center mt-6">{{ props.desc }}</p>
            <div class="w-full overflow-y-hidden lg:overflow-hidden no-scrollbar py-8 pl-10 lg:pl-0">
                <div class="w-max lg:w-full relative flex items-center lg:justify-center gap-4 lg:gap-8">
                    <div 
                        v-for="post in posts"
                        :key="post.title"
                        class="w-70 lg:w-87.5 bg-white p-5 rounded-2xl shadow-gray-s flex flex-col gap-5 border
                            border-transparent transition-all duration-300 hover:shadow-primary-m
                            hover:border-primary-100"
                    >
                        <img
                            width="400"
                            :src="post.img"
                            :alt="post.imgAlt"
                            loading="lazy"
                            class="w-full aspect-video object-cover rounded-xl"
                        />
                        <h3 class="text-body2-bold text-gray-500 line-clamp-2 h-10">{{ post.title }}</h3>
                        <ChipsBase 
                            type="Secondary" 
                            variant="warning" 
                            size="Small"
                        >
                            {{ post.category }}
                        </ChipsBase>
                        <p class="text-caption text-gray-400 line-clamp-3 h-14.8">{{ post.desc }}</p>
                        <Button
                            type="Thirdly"
                            size="Small"
                            :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                            link
                            :to="post.path" 
                            target="_blank" 
                            class="w-fit mt-auto"
                        >
                            بیشتر بخوانید
                        </Button>
                    </div>
                </div>
            </div>
            <Button
                variant="white"
                :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                pill
                link
                :to="useRuntimeConfig().public?.BLOG_URL" 
                target="_blank" 
                class="mx-auto! w-fit!"
            >
                مشاهده همه مقالات
            </Button>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    bg-linear-to-b from-transparent to-primary-50 relative
}
.background::before {
    @apply
    content-[''] w-full h-full absolute top-0 left-0 bg-[url('/img/new/backgrounds/mesh-04.webp')] opacity-70
}
</style>